var exports = {
  "yw": "avatarGrid___nXATx",
  "X": "avatarGridItem__byZPlF",
  "Ce": "avatarList__ETdWjN",
  "Jj": "avatarListItem__miG8ah",
  "cp": "avatarLink__STss1l",
  "LL": "contributorName__g0E5_T",
  "Ye": "nameLink__WgUePC",
  "vR": "profileName__zWMCK6",
  "p$": "emptyState__4RNm3Z",
};

module.exports = exports;
